module.exports = __webpack_public_path__ + "img/img-hero.ead2597.png";